var map = {
	"./1.jpg": "7e1e",
	"./2.jpg": "e97e",
	"./3.jpg": "7bbc",
	"./a1.jpg": "a8c4",
	"./a2.jpg": "bf7b",
	"./a3.jpg": "32e9",
	"./a4.jpg": "3ab4",
	"./a5.jpg": "9946",
	"./a6.jpg": "3e78",
	"./banner.jpg": "f5b1",
	"./banner_fh.jpg": "6f8d",
	"./banner_wl.jpg": "eb48",
	"./banner_wlx.jpg": "ee37",
	"./banner_xg.jpg": "166f",
	"./fh_code_1.png": "1521",
	"./fh_code_2.png": "f769",
	"./fh_code_3.png": "acb2",
	"./fh_code_4.png": "4743",
	"./fh_code_5.png": "d2d9",
	"./fh_code_6.png": "e5c9",
	"./fh_slider1.jpg": "695a",
	"./fh_slider2.jpg": "89e2",
	"./fh_slider3.jpg": "5ba1",
	"./fh_slider4.jpg": "406d",
	"./fh_slider5.jpg": "dcb9",
	"./fh_slider6.jpg": "c661",
	"./icon_1.png": "38b7",
	"./icon_2.png": "b7f8",
	"./icon_3.png": "99ba",
	"./icon_4.png": "7bda",
	"./icon_5.png": "5b4c",
	"./icon_6.png": "c1ad",
	"./icon_big.png": "b1ff",
	"./wl_code_1.png": "0b59",
	"./wl_code_2.png": "2a13",
	"./wl_prod1_1.jpg": "26b6",
	"./wl_prod1_2.jpg": "e57d",
	"./wl_prod1_3.jpg": "153d",
	"./wl_prod1_4.jpg": "d312",
	"./wl_prod1_5.jpg": "9786",
	"./wl_prod1_6.jpg": "117e",
	"./wl_prod1_7.jpg": "b64b",
	"./wl_prod2_1.jpg": "7282",
	"./wl_prod2_2.jpg": "1632",
	"./wl_prod2_3.jpg": "9c85",
	"./wl_prod2_4.jpg": "a2c3",
	"./wl_sl1.jpg": "c7ab",
	"./wl_sl2.jpg": "17cd",
	"./wl_sl3.jpg": "d284",
	"./wl_sl4.jpg": "87f1",
	"./wl_slider1.jpg": "a96d",
	"./wl_slider2.jpg": "c5b4",
	"./wl_v1.png": "a58f",
	"./wl_v2.png": "afed",
	"./wl_v3.png": "1ae4",
	"./wlx_code_1.png": "08f1",
	"./wlx_code_2.png": "ca5e",
	"./xg_code_1.png": "c7fc",
	"./xg_slider1.jpg": "bdbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db12";